<template>
  <div id="issueItemComp" @click="$emit('click')">
    <div class="title">
      <i class="icon icon-wen"></i>
      <div class="issue text-ellipsis">{{detail.name}}</div>
    </div>
    <div class="answerer">
      <div class="userInfo">
        <van-image class="avatar" :src="detail.avatar" round fit="cover"></van-image>
        <div class="name">{{detail.nickname}}</div>
      </div>
      <div class="date">{{detail.createTime | formatDate('yyyy年MM月dd日')}}</div>
    </div>
    <div class="content omit rich-text"  v-html="detail.contentText"></div>
    <div class="bottom">
      <div class="left">
        <div class="tag">
          <img class="icon" :src="require('@/assets/images/issue/icon_issue_02.png')" />
          <span class="text-ellipsis">{{detail.circleName}}</span>
        </div>
      </div>
      <div class="operation">
        <div class="eye item">
          <img class="icon" :src="require('@/assets/images/issue/icon_fire_01.png')" />
          <span>{{detail.heat}}</span>
        </div>
        <div class="comment item">
          <img class="icon" :src="require('@/assets/images/issue/icon_comment_01.png')" />
          <span>{{detail.answer}}</span>
        </div>
        <div class="star item">
          <img class="icon" :src="require('@/assets/images/issue/icon_star_01.png')" />
          <span>{{detail.followers}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IssueItemComp',
  props: {
    detail: {
      type: Object,
      default () {
        return {};
      }
    }
  }
};
</script>

<style lang="less" scoped>
#issueItemComp {
  padding: 40px 0;
  margin: 0 28px;
  border-bottom: 1px solid #F0F0F0;
  .title {
    display: flex;
    align-items: center;
    .icon {
      width: 34px;
      height: 34px;
      &.icon-wen{
        background-image: url("~@/assets/images/issue/icon_wen_02.png");
      }
    }
    .issue {
      flex: 1;
      width: 0;
      font-weight: bold;
      font-size: 32px;
      color: #333444;
      margin-left: 12px;
    }
  }
  .answerer {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .userInfo {
      display: flex;
      align-items: center;
      flex: 1;
      .avatar {
        width: 40px;
        height: 40px;
      }
      .name {
        width: 0;
        flex: 1;
        margin-left: 12px;
        font-size: 26px;
        color: #333444;
        .text-overflow();
      }
    }
    .date {
      font-size: 26px;
      color: #999AAA;
    }
  }
  .content {
    margin-top: 28px;
    font-size: 28px;
    color: #333444;
  }
  .bottom {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      flex: 1;
      width: 0;
      display: flex;
      .tag {
        height: 44px;
        background: #F7F8FA;
        border-radius: 24px;
        display: flex;
        align-items: center;
        padding-left: 16px;
        padding-right: 16px;
        .icon {
          flex-shrink: 0;
          width: 26px;
          height: 26px;
        }
        span {
          margin-left: 8px;
          font-size: 24px;
          color: #333444;
        }
      }
    }

    .operation {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        display: flex;
        align-items: center;
        .icon {
          width: 32px;
          height: 32px;
        }
        span {
          margin-left: 8px;
          font-size: 24px;
          color: #999AAA;
        }
      }
    }
  }
}
</style>